document.addEventListener('DOMContentLoaded', function (){
    const element=document.querySelector(".btn--chat");
    if (element) {
        element.addEventListener("click", e=>{
            e.preventDefault();
            window.HubSpotConversations ?
                window.HubSpotConversations.widget.open() : window.hsConversationsOnReady=[()=>{window.HubSpotConversations.widget.open()}]
        });
    }
});
